/* Load once, after product-map.js and storefront-popup.js. */
(function () {
  const node = document.getElementById('RakabotPopupContext');
  if (!node || !window.RakabotWelcomePopup) return;
  let context;
  try { context = JSON.parse(node.textContent); } catch (_) { return; }
  window.RakabotPopupContext = context;
  window.RakabotWelcomePopup.start({
    enabled: context.enabled === true,
    getLanguage: () => context.language,
    getProduct: () => context,
    isEligible: () => context.customerLoggedIn !== true
  });
})();
